import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { CustomerDashboardRoutingModule } from "./customer-dashboard-routing.module";
import { CustomerDashboardGeneralComponent } from "./view/customer-dashboard-general/customer-dashboard-general.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CustomerSideMenuComponent } from "./components/customer-side-menu/customer-side-menu.component";
import { CustomerInformationTabsComponent } from "./components/customer-information-tabs/customer-information-tabs.component";
import { ServiceTicketsTableComponent } from "./components/service-tickets-table/service-tickets-table.component";
import { FurySharedModule } from "src/@fury/fury-shared.module";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTableModule } from "@angular/material/table";
import { MatMenuModule } from "@angular/material/menu";
import { AgreementsTableComponent } from "./components/grids/agreements/agreements-table/agreements-table.component";
import { AgreementsTabsComponent } from "./components/grids/agreements/agreements-tabs/agreements-tabs.component";
import { MatPaginatorModule } from "@angular/material/paginator";
import { NgxPaginationModule } from "ngx-pagination";
import { LeadsTabsComponent } from './components/grids/leads/leads-tabs/leads-tabs.component';
import { LeadsTableComponent } from './components/grids/leads/leads-table/leads-table.component';
import { EditCustomerComponent } from './components/edit-customer/edit-customer.component';
import { feedbackTabsComponent } from "./components/grids/feedback/feedback-tabs/feedback-tabs.component";
import { feedbackTableComponent } from "./components/grids/feedback/feedback-table/feedback-table.component";
import { MaterialModule } from 'src/@fury/shared/material-components.module';
import { NgxMaskModule } from "ngx-mask";
import {MatDialogModule} from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { NgOptimizedImage } from '@angular/common';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule, NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';
import { SharedModule } from "src/app/shared/shared.module";

import { NotesTabsComponent } from './components/grids/notes/notes-tabs/notes-tabs.component';
import { NotesTableComponent } from './components/grids/notes/notes-table/notes-table.component';
import { SpecialRequestComponent } from './components/special-request/special-request.component';
import { SpecialRequestTableComponent } from './components/grids/special-requests/special-request-table/special-request-table.component';
import { SpecialRequestTabsComponent } from './components/grids/special-requests/special-request-tabs/special-request-tabs.component';
import { LeadGenerateComponent } from './components/service-agreement/lead-generate/lead-generate.component';
import { CoverNotCoverComponent } from './components/service-agreement/cover-not-cover/cover-not-cover.component';
import { CheckoutComponent } from './components/service-agreement/checkout/checkout.component';
import { ChangeAddressComponent } from './components/service-agreement/modal/change-address/change-address.component';
import { EditPropertyComponent } from "./components/service-agreement/modal/edit-property/edit-property.component";
import { CommonCardDetailsFormComponent } from "./components/service-agreement/common/common-card-details-form/common-card-details-form.component";
import { CommonSummarySectionComponent } from "./components/service-agreement/common/common-summary-section/common-summary-section.component";
import { AddClaimComponent } from "./components/add-claim/add-claim.component";
import { FindAgreementNumberModalComponent } from "./components/add-claim/find-agreement-number-modal/find-agreement-number-modal.component";
import { ClaimTableComponent } from './components/grids/claims/claim-table/claim-table.component';
import { ClaimTabComponent } from './components/grids/claims/claim-tab/claim-tab.component';
import { EditPlanTypeComponent } from './components/service-agreement/modal/edit-plan-type/edit-plan-type.component';
import { PayoutInfoModalComponent } from './components/modals/payment-info-modal/payout-info-modal.component';
import { ViewClaimComponent } from './components/view-claim/view-claim.component';
import { ViewAgreementComponent } from './components/view-agreement/view-agreement.component';
import { ClaimActionModalComponent } from './components/modals/claim-action-modal/claim-action-modal.component';
import { ClaimStatusComponent } from './components/grids/claims/claim-status/claim-status.component';
import { ClaimStatusHistoryTableComponent } from './components/grids/claims/claim-status-history-table/claim-status-history-table.component';
import { UploadDocumentModalComponent } from './components/modals/upload-document-modal/upload-document-modal.component';
import { ClaimsSideMenuComponent } from './components/view-claim/claims-side-menu/claims-side-menu.component';
import { ClaimActionsService } from "./services/claim-actions.service";
import { ViewNoteModalComponent } from './components/modals/view-note-modal/view-note-modal.component';
import { CommonLabelSectionComponent } from './components/common-label-section/common-label-section.component';
import { ChargeManuallyModalComponent } from './components/modals/charge-manually-modal/charge-manually-modal.component';
import { PaymentsTabsComponent } from './components/grids/payments/payments-tabs/payments-tabs.component';
import { PaymentsTableComponent } from './components/grids/payments/payments-table/payments-table.component';
import { CheckPaymentModalComponent } from './components/modals/check-payment-modal/check-payment-modal.component';
import { ComplaintModalComponent } from './components/modals/complaint-modal/complaint-modal.component';
import { AgreementActionsModalComponent } from './components/modals/agreement-actions-modal/agreement-actions-modal.component';
import { ManageOptionalItemModalComponent } from './components/modals/manage-optional-item-modal/manage-optional-item-modal.component';
import { CancelAgreementModalComponent } from './components/modals/cancel-agreement-modal/cancel-agreement-modal.component';
import {MatStepperModule} from '@angular/material/stepper';
import { BillingTabsComponent } from './components/grids/billing-history/billing-tabs/billing-tabs.component';
import { BillingTableComponent } from './components/grids/billing-history/billing-table/billing-table.component';
import { UpgradeDowngradeAgreementModalComponent } from './components/modals/upgrade-downgrade-agreement-modal/upgrade-downgrade-agreement-modal.component';
import { CoverItemDetailsModalComponent } from './components/modals/cover-item-details-modal/cover-item-details-modal.component';
import { TransferAgreementComponent } from './components/modals/transfer-agreement/transfer-agreement.component';
import { RenewAgreementComponent } from './components/modals/renew-agreement/renew-agreement.component';
import { RetentionComponent } from './components/grids/retention/retention.component';
import { AssignAgreementComponent } from './components/modals/assign-agreement/assign-agreement.component';
import { NoteModalComponent } from './components/modals/note-modal/note-modal.component';
import { FeedbackRequestModalComponent } from './components/modals/feedback-request-modal/feedback-request-modal.component';
import { ViewAssignedTechnicianComponent } from './components/modals/view-assigned-technician/view-assigned-technician.component';
import { ClaimPrioritizationModalComponent } from './components/modals/claim-prioritization-modal/claim-prioritization-modal.component';

@NgModule({
  declarations: [
    CustomerDashboardGeneralComponent,
    CustomerSideMenuComponent,
    CustomerInformationTabsComponent,
    ServiceTicketsTableComponent,
    AgreementsTableComponent,
    AgreementsTabsComponent,
    LeadsTabsComponent,
    LeadsTableComponent,
    EditCustomerComponent,
    feedbackTabsComponent,
    feedbackTableComponent,
    NotesTabsComponent,
    NotesTableComponent,
    SpecialRequestComponent,
    SpecialRequestTableComponent,
    SpecialRequestTabsComponent,
    LeadGenerateComponent,
    CoverNotCoverComponent,
    CheckoutComponent,
    ChangeAddressComponent,
    EditPropertyComponent,
    CommonCardDetailsFormComponent,
    CommonSummarySectionComponent,
    AddClaimComponent,
    FindAgreementNumberModalComponent,
    ClaimTableComponent,
    ClaimTabComponent,
    EditPlanTypeComponent,
    PayoutInfoModalComponent,
    ViewClaimComponent,
    ViewAgreementComponent,
    ClaimActionModalComponent,
    ClaimStatusComponent,
    ClaimStatusHistoryTableComponent,
    UploadDocumentModalComponent,
    ClaimsSideMenuComponent,
    ViewNoteModalComponent,
    CommonLabelSectionComponent,
    ChargeManuallyModalComponent,
    PaymentsTabsComponent,
    PaymentsTableComponent,
    CheckPaymentModalComponent,
    ComplaintModalComponent,
    AgreementActionsModalComponent,
    ManageOptionalItemModalComponent,
    CancelAgreementModalComponent,
    BillingTabsComponent,
    BillingTableComponent,
    UpgradeDowngradeAgreementModalComponent,
    CoverItemDetailsModalComponent,
    TransferAgreementComponent,
    RenewAgreementComponent,
    RetentionComponent,
    AssignAgreementComponent,
    NoteModalComponent,
    FeedbackRequestModalComponent,
    ViewAssignedTechnicianComponent,
    ClaimPrioritizationModalComponent
  ],
  imports: [
    CommonModule,
    CustomerDashboardRoutingModule,
    ReactiveFormsModule,
    FurySharedModule,
    MatExpansionModule,
    MatSidenavModule,
    MatTabsModule,
    MatTableModule,
    MatMenuModule,
    NgxPaginationModule,
    MatPaginatorModule,
    MaterialModule,
    NgxMaskModule,
    MatDialogModule,
    NgOptimizedImage,
    FormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    SharedModule,
    MatStepperModule
  ],
  providers: [ClaimActionsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CustomerDashboardModule {}
